import React from "react";
import { observer } from "mobx-react";
import { ShowcaseLineUpdateStore } from "../../store";
import { ShowcaseLineUpdateForm } from "./ShowcaseLineUpdateForm";
import { ErrorDialog, ConfirmCancelDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";

export type ShowcaseLineUpdateProps = {
  showcaseLineUpdateStore: ShowcaseLineUpdateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const ShowcaseLineUpdate: React.FC<ShowcaseLineUpdateProps> = observer(
  ({ showcaseLineUpdateStore, showToolbox = true, showSaveFooter }) => {
    return (
      <>
        <SavingOverlay open={showcaseLineUpdateStore.isSaving} />
        <ShowcaseLineUpdateForm
          showcaseLineUpdateStore={showcaseLineUpdateStore}
          conceptError={showcaseLineUpdateStore.errors.concept?.message}
          onConceptChange={(value: string) => {
            showcaseLineUpdateStore.setConceptValue(value);
          }}
          concept={showcaseLineUpdateStore.entityValues.concept}
          quantityError={showcaseLineUpdateStore.errors.quantity?.message}
          onQuantityChange={(value: number) => {
            showcaseLineUpdateStore.setQuantityValue(value);
          }}
          quantity={showcaseLineUpdateStore.entityValues.quantity}
          unitPriceError={showcaseLineUpdateStore.errors.unitPrice?.message}
          onUnitPriceChange={(value: number) => {
            showcaseLineUpdateStore.setUnitPriceValue(value);
          }}
          unitPrice={showcaseLineUpdateStore.entityValues.unitPrice}
          noteError={showcaseLineUpdateStore.errors.note?.message}
          onNoteChange={(value: string) => {
            showcaseLineUpdateStore.setNoteValue(value);
          }}
          note={showcaseLineUpdateStore.entityValues.note}
          showToolbox={showToolbox}
          showSaveFooter={showSaveFooter}
          saving={showcaseLineUpdateStore.saveDisabled}
          onSave={() => showcaseLineUpdateStore.saveShowcaseLine()}
          onCancel={() => showcaseLineUpdateStore.cancelShowcaseLine()}
        />
        <ErrorDialog
          open={showcaseLineUpdateStore.errorDialogOpened}
          title={showcaseLineUpdateStore.errorTitle}
          description={showcaseLineUpdateStore.errorDescription}
          onClose={() => showcaseLineUpdateStore.closeErrorDialog()}
        />
        <ConfirmCancelDialog
          open={showcaseLineUpdateStore.confirmDialogOpened}
          title={showcaseLineUpdateStore.confirmDialogTitle}
          description={showcaseLineUpdateStore.confirmDialogDescription}
          onConfirm={() => showcaseLineUpdateStore.executeConfirmedAction()}
          onCancel={() => showcaseLineUpdateStore.closeConfirmDialog()}
        />
      </>
    );
  }
);
